'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// ./node_modules/get-proto/Reflect.getPrototypeOf.js
// module id = 154
// module chunks = 0